import { useContext, useEffect } from 'react';
import { StoreContext } from '../../store';

import { ReactComponent as Check } from '../../assets/check-badge.svg';

const SuccessCheckout = ({ session_id }) => {
  const { navigate } = useContext(StoreContext);

  const goToMainPage = () => {
    window.location.replace(`/`);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      goToMainPage();
    }, 10000);

    return () => clearTimeout(timer);
  }, [])

  return (
    <div className="flex flex-col items-center justify-center h-screen w-full bg-[#f2f4f5]">
      <div className='rounded-lg bg-white shadow-lg p-6 w-96 text-center flex flex-col items-center gap-2'>
        <Check className='h-[72px] w-auto' />
        <div className='text-[#f1592a] text-lg font-medium'>
          Thank you for subscribing!
        </div>
        <div className='text-gray-500'>
          Sucessfuly updated your subscription
        </div>
        <div className='mt-4 text-sm'>
          You will be redirected to the main page shortly or click here to return to the main page
        </div>
        <div
          className='bg-[#f1592a] text-white rounded-lg px-4 py-2 mt-4 cursor-pointer'
          onClick={() => goToMainPage()}
        >
          Back to main page
        </div>
      </div>
    </div>
  );
};

export default SuccessCheckout;